<template>
    <div
        class="md-demographic broker"
        :style="{ marginBottom }"
        v-if="exist"
        v-show="visible"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div class="title-container">
                <div
                    class="mg-title"
                    v-html="formatFontSize(title, '--mg-title-size')"
                ></div>
                <a
                    :href="listingDetail.introUrlByListing"
                    v-if="listingDetail.introUrlByListing"
                    rel="noopener noreferrer"
                    class="refine-intro"
                ><i class="iconfont icon-community"></i>{{ $t('md-demographic.refineSearch') }}</a>
            </div>
            <ul class="demographic-content">
                <li
                    v-for="item in demographics"
                    class="item"
                    :key="'item' + item.label"
                >
                    <div class="info">
                        <p class="number" data-format="${item.type}">
                            {{ item.value }}
                        </p>
                        <p class="text">{{ item.label }}</p>
                    </div>
                    <div class="icon">
                        <i class="iconfont" :class="[adaptIcon(item)]"></i>
                    </div>
                </li>
            </ul>
            <div
                class="source"
                v-html="$t('md-demographic.dataProvidedBy')"
            ></div>
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
import { colorBlock } from '../../defaultSpacing';
export default {
    mixins: [Common],
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    data: function() {
        return {
            ...colorBlock
        };
    },
    methods: {
        adaptIcon(item) {
            const icons = [
                'icon-Population',
                'icon-a-MedianAge',
                'icon-a-BachelorDegree',
                'icon-dollor'
            ];
            const regs = [
                /population/gi,
                /median\sage/gi,
                /school/gi,
                /income/gi
            ];
            const [reg] = regs.filter(reg => reg.test(item.label));
            const index = regs.indexOf(reg);
            const className = icons[index] ? icons[index] : icons[0];
            return className;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-demographic.broker {
    overflow: visible;
    .mg-container {
        overflow: visible;
        .title-container {
            display: flex;
            align-content: center;
            justify-content: space-between;
            .refine-intro {
                font-size: 14px;
                color: #505050;
                font-family: var(--font-medium);
                line-height: 26px;
                display: flex;
                align-items: center;
                white-space: nowrap;
                .iconfont.icon-community {
                    margin-right: 10px;
                    color: #a8a8a8;
                }
            }
            .mg-title {
                flex-basis: fit-content;
                margin-left: 0;
            }
        }
    }
    .mg-title {
        padding-bottom: 0;
        color: #191919;
        font: 24px var(--font-bold);
    }
    .source {
        padding: 10px 0;
        color: var(--color-info);
        font-size: 12px;
        line-height: 16px;
        a {
            text-decoration: underline;
            color: var(--color-theme, #03c9ff);
        }
    }
    .demographic-content {
        margin-top: 20px;
        background: white;
        position: relative;
        overflow: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        @include always-show-scroll('#999', '4px', '4px');
        li {
            min-width: 235px;
            min-height: 140px;
            background-color: #f7f7f7;
            border-radius: 5px;
            overflow: hidden;
            border-top: 6px solid var(--color-theme);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 0 26px;
            flex: 1;
            .info {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                .number {
                    margin-bottom: 7px;
                    font: 24px var(--font-bold);
                    color: var(--color-theme);
                    line-height: 35px;
                }
                .text {
                    font: 14px var(--font-bold);
                    line-height: 18px;
                    color: #191919;
                }
            }
            .icon {
                width: 44px;
                height: 44px;
                line-height: 44px;
                border-radius: 50%;
                border: 1px solid #dadada;
                text-align: center;
                flex-shrink: 0;
                .iconfont {
                    &.icon-Population {
                        color: #1774f1;
                    }
                    &.icon-a-MedianAge {
                        color: #5452ce;
                    }
                    &.icon-a-BachelorDegree {
                        color: #17b124;
                    }
                    &.icon-dollor {
                        font-size: 18px;
                        color: #ff781d;
                    }
                }
            }
        }
    }
    @include media-600 {
        .mg-title {
            font: 16px var(--font-bold);
            color: #191919;
        }
        .demographic-content {
            flex-direction: column;
            margin-top: 15px;
        }
    }
}
</style>
